define(['jquery'], function( $) {

    function getProductDataTracking(){
        var trackingData = $('.tracking-product-data-js').data().trackingProductDataServiceOptions;
        if( trackingData ){
            return {
                product: [
                    {
                        bundleId: trackingData.bundleId,
                        itemId: undefined, // Undefined so the $.extend could merge and take it from the other object
                        name: trackingData.productName,
                        productId: trackingData.productId
                    }
                ],
                rewardEligibility: {
                    orderId: undefined,
                    rewardOptionEligible: undefined,
                    rewardsAdded: undefined
                },
                action: 'update'
            };
        }
        return null;
    }
    function getProductData($productForm, responseDataObject){
        var partNumber, bundleId, itemId, orderId, productId;
        if( responseDataObject.partNumber && responseDataObject.partNumber.length > 0){
            partNumber = responseDataObject.partNumber[0];
        }
        bundleId = $productForm.find('input[name="bundle-part-number"]' ).val();
        itemId = $productForm.find('input[name="item-part-number"]' ).val();
        if( responseDataObject.orderId && responseDataObject.orderId.length > 0 ){
            orderId = responseDataObject.orderId[0];
        }
        if( !partNumber ){
            var productFormData = $productForm.data();
            bundleId = productFormData.bundlePartNumber;
            itemId = itemId || productFormData.childPartNumber;
            var productFormDataArr = $productForm.serializeArray();
            dataObj = {};
            $(productFormDataArr).each(function(i, field){
                dataObj[field.name] = field.value;
            });
            productId = dataObj.productCode;
            if( !productId){
                productId = productFormData.productPartNumber;
            }
            var colorAttrData = $('.attr-container-js > .attr-box.selected.clicked > img').first().data(); //This selector represents the current selected/active color swatch
            if( colorAttrData && colorAttrData.productName ){
                partNumber = colorAttrData.productName;
            }
            if( !partNumber && productId ){
                partNumber = productId;
            }


        }
        var data = {
            product: [
                {
                    bundleId: bundleId,
                    itemId: itemId,
                    name: partNumber,
                    productId: productId
                }
            ],
            rewardEligibility: {
                orderId: orderId,
                rewardOptionEligible: responseDataObject.rewardOptionEligible,
                rewardsAdded: responseDataObject.rewardsAdded
            },
            action: 'update'
        };
        return data;
    }

    return {getProductData: getProductData, getProductDataTracking: getProductDataTracking};
});
